import { Col, Container, Row } from 'react-bootstrap'
import workYourAssOff from 'assets/images/maintainpage-workworkwork.svg'
import countdownBg from 'assets/images/maintainpage-countdownbg.svg'
import { useTranslation } from 'react-i18next'
import MaintainCountdown from 'components/Countdown'

function MaintainPage() {
	const { t } = useTranslation()

	return (
		<Container fluid className="maintainpage-container">
			<Row>
				<Col xs={12} md={7} lg={8} className="content">
					<h1>{t('maintain_page.title')}</h1>
					<p className="mt-3">{t('maintain_page.content')}</p>
					<MaintainCountdown />
				</Col>
				<Col xs={12} md={5} lg={4} className="ass-off">
					<img
						src={workYourAssOff}
						className="mx-auto mx-md-0 mt-3 mt-md-0"
						alt="We are currently maintain the website. Please come back later."
					/>
				</Col>
			</Row>
		</Container>
	)
}

export default MaintainPage
